export enum CaseAISubmitType {
  NEW_ANALYSIS = 'new_analysis',
  CONTINUE_ANALYSIS = 'continue_analysis'
}

export interface CaseAISubmitDialogProps {
  open: boolean;
  setOpen: (isOpen: boolean) => void;
}
